import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { update_page_meta } from "../actions/page/header";
import { HomePageURL } from "../assets/const";

const Home = ({ update_page_meta }) => {
  let navigate = useNavigate();
  useEffect(() => {
    navigate(`${HomePageURL}/stores/`, { replace: true });
  });
  update_page_meta({
    title: "Dashboard",
  });
  return <>Home</>;
};

export default connect(null, { update_page_meta })(Home);
